import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-310">
      <div className="max-w-3xl mx-auto text-center" data-id="element-311">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-312">
          Si sos profe de pádel en Argentina,
          <br data-id="element-313" />
          <span className="text-[#00B4D8]" data-id="element-314">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-315">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-316">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-317">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-318">
              Llegás a la cancha sin saber exactamente qué ejercicio vas a dar
              hoy
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-319">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-320">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-321">
              Tus alumnos más principiantes no progresan porque no tenés una
              secuencia clara de niveles
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-322">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-323">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-324">
              El 60% de los alumnos abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-325">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-326">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-327">
              Cuando llueve cancelás y perdés el ingreso porque no tenés un Plan
              B listo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-328">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-329">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-330">
              No podés justificar un aumento de precio porque no tenés un
              sistema profesional visible
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-331">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-332">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-333">
              Siempre las mismas correcciones improvisadas, sin un método claro
              que te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-334">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-335">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-336">
              Tenés alumnos de distintos niveles juntos y la clase se convierte
              en un caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-337">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-338">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-339">
              Fin de mes y no sabés exactamente cuánto vas a cobrar porque el
              cobro es un desastre
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-340">
          ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-341" />
      </div>
    </section>;
}